const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.699,
    height: 24.073,
    viewBox: "0 0 83.699 24.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5159"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5161"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13826",
    d: "m1.117 12.037 7.37 9.922a3.372 3.372 0 0 0 2.686 1.115h68.4c1.656 0 3-.9 3-2.011V3.011C82.57 1.9 81.226 1 79.57 1h-68.4a3.372 3.372 0 0 0-2.683 1.115z",
    transform: "translate(.129)",
    style: {
      fill: "none",
      stroke: "#313280",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartMobile);
export default __webpack_public_path__ + "static/media/startMobile.de194fd6e5aec621bf0952eb3e8dc45b.svg";
export { ForwardRef as ReactComponent };